// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","textBtn":"Button_textBtn__Dxe7d","nextBtn":"Button_nextBtn__TgNBW"};